import React from "react";
import { Skeleton } from "primereact/skeleton";

const DocumentLoading: React.FC = () => {
    return (
        <div className="p-4">
            <div className="content_load_head mb-3">
                <Skeleton shape="circle" size="3.5rem" className="mb-2 flex-shrink-0"></Skeleton>
                <div className="w-100">
                    <Skeleton className="mb-2 w-100"></Skeleton>
                    <Skeleton className="mb-2 w-50"></Skeleton>
                </div>
            </div>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-3 w-50"></Skeleton>

            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-3 w-75"></Skeleton>

            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-100"></Skeleton>
            <Skeleton className="mb-2 w-25"></Skeleton>
        </div>
    )
}

export default DocumentLoading;